<div class="row">
    <div class="col-12 mb-4">
		<div class="card rounded-top-left-0">
			<div class="card-header d-flex justify-start items-center gap-2">
				<h3>Listas de Destinos</h3>
				<span 
				class="a-hover font-bold text-primary cursor-pointer" 
				(click)="showModalCreate = true">
					<i class="fa fa-plus"></i> Agregar Destino
				</span>
			</div>
			<div class="card-body">
				<div>
                    <div *ngIf="destinations.length === 0">
                        <p class="muted">
                            <i class="fa fa-circle-info"></i> No se tiene lista de precios
                        </p>
                    </div>
                    <div>
                        <div class="row" id="options-other-filters">
                            <div class="col-sm form-group">
                                <label for="filterVendors" class="form-label">Filtrar</label>
                                <div class="input-group input-group-sm">
                                    <input
                                        type="text"
                                        id="filter"
                                        [(ngModel)]="filterWord"
                                        (input)="onInputChange($event)"
                                        placeholder="Filtra destino por nombre"
                                        name="filter"
                                        class="form-control"
                                    />
                                    <button class="btn btn-primary" (click)="searching()">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <p class="muted">
                            <i class="fa fa-circle-info"></i> Selecciona un destino
                        </p>
                    </div>
                    <div class="row">
                        <div class="mb-4">
                            <!-- <ul class="px-0 border rounded">
                                <ng-container *ngFor="let item of pagination.filter">
                                    <li (click)="setPriceListSelected(item)" style="list-style-type: none; cursor: pointer;" class="hover:bg-body px-2" [class.bg-blue-600]="item.id==destinationsSelectedId">
                                        <div class="d-flex flex-row justify-between items-center py-2">
                                            <div>
                                                {{item.name}}
                                            </div>
                                            <div>
                                                {{item.id==destinationsSelectedId}}
                                            </div>
                                        </div>
                                    </li>
                                </ng-container>
                            </ul> -->
                            <table class="table table-hover table-responsive table-bordered">
                                <thead>
                                    <tr >
                                        <th class="text-center">Activo</th>
                                        <th>Nombre</th>
                                        <th class="text-center">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let item of pagination.filter">
                                        <tr class="px-2"
                                        >
                                            <td class="td-center">
                                                <i *ngIf="!updatingActive[item.id]" tooltip="Activa/Desactiva estado del destino"
                                                    (click)="setActiveDestination(item)"
                                                    [ngClass]="item.active?'fa-toggle-on text-success':'fa-toggle-off'"
                                                    class="fa active clickeable"></i>
                                                <span *ngIf="updatingActive[item.id]"
                                                    [ngClass]="item.active?'text-secondary':'text-success'"
                                                    class="spinner-border spinner-border-sm"></span>
                                            </td>
                                            <td [class.bg-blue-50]="item.id==destinationSelectedId"
                                            [class.font-bold]="item.id==destinationSelectedId"
                                            >
                                                <div class="input-group-sm d-flex flex-row" *ngIf="editDestination[item.id]">
                                                    <input type="text" 
                                                        placeholder="Nombre" 
                                                        class="form-control"
                                                        [(ngModel)]="item.name"
                                                        >
                                                    <button class="btn btn-success" (click)="updateList(item)"
                                                        [disabled]="loadingUpdate[item.id]">
                                                        <i class="fa fa-save" *ngIf="!loadingUpdate[item.id]"></i>
                                                        <span class="spinner-border spinner-border-sm" *ngIf="loadingUpdate[item.id]"></span>
                                                    </button>
                                                </div>
                                                <div *ngIf="!editDestination[item.id]">
                                                    {{item.name}}
                                                </div>
                                            </td>
                                            <td class="text-right"
                                            [class.bg-blue-50]="item.id==destinationSelectedId"
                                            [class.font-bold]="item.id==destinationSelectedId"
                                            >
                                                <div class="d-flex flex-wrap items-center justify-center gap-1">
                                                    <span class="a-hover" (click)="editingName(item)">
                                                        <i class="fa fa-edit text-primary"></i>
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="tr-middle" *ngIf="loading">
                                            <td colspan="4">
                                                <app-loading-animation [height]="'5rem'"></app-loading-animation>
                                                <p class="display-6">Cargando</p>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                            <app-pagination-custom [elements]="pagination"></app-pagination-custom>
                        </div>
                    </div>
                </div>
			</div>
		</div>
	</div>
</div>

<app-modal-dialog 
*ngIf="showModalCreate" 
[show]="showModalCreate" 
[title]="'Agregar Destino'"
[showHeader]="true"
[size]="'md'"
(closed)="closeModal($event)"
>
	<div modal-body>
		<div class="input-group col mb-4">
			<input type="text" 
				placeholder="Nombre" 
				class="form-control"
				[(ngModel)]="destinationName"
			>
		</div>
		<div class="input-group col justify-end text-left">
			<ng-container *ngIf="loadingCreate">
				<button class="btn btn-success" [disabled]="loadingCreate">
					<i class="fa fa-spinner"></i> Agregando
				</button>
			</ng-container>
			<ng-container *ngIf="!loadingCreate">
				<button class="btn btn-success" (click)="addList()">
					<i class="fa fa-floppy-disk"></i> Agregar
				</button>
			</ng-container>
		</div>
	</div>

</app-modal-dialog>